module.exports = __webpack_public_path__ + "static/img/process-control.5f5cb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-control.png
// module id = WFLB
// module chunks = 1